import axios from 'axios';
import tinysort from 'tinysort';
import bem from '../modules/bem';
import utils from '../modules/utils';
import viewport from '../modules/viewport';

class Card {

	static get block() {
		return bem.block('card');
	}

	get id() {
		return this._id;
	}

	static get counter() {
		Card._counter = (Card._counter || 0) + 1;
		return Card._counter;
	}

	constructor($card){

		if( $card.classList.contains(Card.block.class(false, bem.states.initialised)) ) return;

		this._id = Card.counter;

		this.settings = {
			breakpoint: 'desktop-small'
		};

		this.selectors = {
			tabsLinks: bem.block('tabs').selector('links'),
			makeDefault: bem.block('card-make-default').selector('checkbox')
		};

		this.$card = {
			root: $card,
			areas: {
				all: $card.querySelectorAll(Card.block.selector('area')),
				main: $card.querySelector(Card.block.selector('area') + '[data-area="main"]')
			},
			wrapper: $card.querySelector('.card-wrapper'),
			header: $card.querySelector('.card-header'),
			body: $card.querySelector('.card-body'),
			footer: $card.querySelector('.card-footer')
		};
		this.$tabs = this.$card.root.querySelector(Card.block.selector('tabs'));
		this.$tabsLinks = this.$tabs.querySelector(this.selectors.tabsLinks);
		this.$content = {
			root: this.$card.root.querySelector(Card.block.selector('content')),
			header: {
				primary: this.$card.header.querySelector('.card-section--primary'),
				secondary: {
					root: this.$card.header.querySelector('.card-section--secondary'),
					entries: this.$card.header.querySelectorAll('.card-section--secondary > *')
				},
				sortable: this.$card.header.querySelectorAll('.data-sort')
			},
			body: {
				entries: this.$card.body.querySelectorAll('.card-entry'),
				secondary: {
					entries: this.$card.body.querySelectorAll('.card-section--secondary > *')
				},
				extra: {
					entries: this.$card.body.querySelectorAll('.card-section--extra > *')
				}
			},
			footer: {
				primary: this.$card.footer.querySelector('.card-section--primary'),
				secondary: {
					root: this.$card.footer.querySelector('.card-section--secondary'),
					entries: this.$card.footer.querySelectorAll('.card-section--secondary > *'),
					makeDefault: this.$card.footer.querySelectorAll(this.selectors.makeDefault)
				}
			}
		};
		this.$allCards = document.getElementById('racecard-all');

		this.busy = false;
		this.tabs = null;
		this.activeID = null;

		this.init = this.init.bind(this);
		this.onTabClick = this.onTabClick.bind(this);
		this.onResize = this.onResize.bind(this);
		this.setLoading = this.setLoading.bind(this);
		this.ajaxTab = this.ajaxTab.bind(this);
		this.updateActiveContent = this.updateActiveContent.bind(this);
		this.checkDefault = this.checkDefault.bind(this);
		this.setupDefaultToggle = this.setupDefaultToggle.bind(this);
		this.setDefaultTab = this.setDefaultTab.bind(this);
		this.swapArea = this.swapArea.bind(this);
		this.ajaxSwapArea = this.ajaxSwapArea.bind(this);
		this.rowHeights = this.rowHeights.bind(this);
		this.sortableSetup = this.sortableSetup.bind(this);
		this.checkHiddenTab = this.checkHiddenTab.bind(this);
		// this.triggerTimeformLogin = this.triggerTimeformLogin.bind(this);

		this.init();

	}

	init(){

		// set initialised state
		this.$card.root.classList.add(Card.block.class(false, bem.states.initialised));

		// assign tabs
		this.tabs = new atr.classes.Tabs(this.$tabs);

		// add click listener to tabs
		this.$tabsLinks.addEventListener('click', this.onTabClick);

		// setup make-default
		this.setupDefaultToggle();

		// setup default tab
		this.setDefaultTab();

		// add sortable columns
		this.sortableSetup();

		// add resize event to reset and check if overflow is required
		viewport.addListener('card' + this.id, this.onResize);
		this.onResize();

	}

	onTabClick(e){

		e.preventDefault();

		const $target = e.target;
		const classList = $target.classList;

		// if we're busy, or already on the active tab, do nothing
		if( this.busy || classList.contains(bem.states.active) ){
			return;
		}

		// if basic link, behave as normal, otherwise assume it's behing handled externally
		if( classList.contains(Card.block.class('tab-basic')) ){

			this.busy = true;

			this.updateActiveContent($target);

		}else if( classList.contains(Card.block.class('tab-ajax')) ){

			this.busy = true;

			this.ajaxTab($target);

		}else if( classList.contains(Card.block.class('tab-swap')) ){

			this.busy = true;

			this.swapArea($target);

		}else if( classList.contains(Card.block.class('tab-swap-ajax')) ){

			this.busy = true;

			this.ajaxSwapArea($target);

		}else if( classList.contains(Card.block.class('tab-printouts')) ){

			// this.busy = true;

			// this.triggerTimeformLogin($target);

		}else if( classList.contains(Card.block.class('tab-timeform-login')) ){

			// this.busy = true;

			// this.triggerTimeformLogin($target);

		}

	}

	setLoading(force){

		const $card = this.$card.root;

		if( force ){

			$card.classList.add('loading', bem.states.loading);

		}else{

			$card.classList.remove(bem.states.loading);

			setTimeout(function(){

				$card.classList.remove('loading');

			}, 200);

		}

	}

	ajaxTab($target){

		const $targetElem = $target;

		const targetData = $target.dataset;

		const selectors = this.selectors;
		const $card = this.$card;
		const $content = this.$content;
		const $allCards = this.$allCards;
		const setLoading = this.setLoading;
		const updateActiveContent = this.updateActiveContent;
		const checkDefault = this.checkDefault;

		// set loading state
		setLoading(true);

		// get the content
		axios
			.get($targetElem.href, {
				headers: {
					'X-Requested-With': 'XMLHttpRequest'
				},
			})
			.then(function(response){

				// get response as an element
				const $response = utils.htmlToElement(response.data);

				// get the relevant parts of the response so we can place in correct location in DOM
				const $responseHTML = {
					root: $response,
					header: $response.querySelector('[data-location="header"] > div'),
					body: $response.querySelectorAll('[data-location="body"] > .row'),
					footer: $response.querySelector('[data-location="footer"] > div')
				};

				// set the content ID
				const contentID = targetData.id;

				// set the tab HREF value (unless it's always AJAX)
				// and update the link
				if( !targetData.alwaysAjax ){
					$targetElem.href = '#' + contentID;

					$targetElem.classList.toggle(Card.block.class('tab-ajax'), false);
					$targetElem.classList.toggle(Card.block.class('tab-basic'), true);
				}

				// if it's an always-ajax call remove the existing version first
				const $existingContent = $card.areas.main.querySelectorAll('[data-id="' + contentID + '"]');

				if( targetData.alwaysAjax ){
					for( let i = 0; i < $existingContent.length; i++ ){
						const $block = $existingContent[i];

						$block.parentNode.removeChild($block);
					}
				}

				// add AJAX'd content to relevent sections of the card

				// add headers
				$content.header.secondary.root.appendChild( $responseHTML.header );

				// insert each body row in to relevant location
				for( let i = 0; i < $responseHTML.body.length; i++ ){
					const $row = $responseHTML.body[i];
					const $rowSecondary = $row.querySelector('[data-location="secondary"]');
					const $rowExtra = $row.querySelector('[data-location="extra"]');
					const rowData = $row.dataset;
					const $entry = $card.body.querySelector('.card-entry[data-index="' + i + '"]');
					const $entrySecondary = $entry.querySelector('.card-section--secondary');
					const $entryExtra = $entry.querySelector('.card-section--extra');

					// append the secondary content
					$entrySecondary.appendChild( $rowSecondary );

					// append any extra content (i.e. timeformplus)
					if( $rowExtra ){
						$entryExtra.appendChild( $rowExtra );
					}

					// attach any data to header (for sorting)
					Object.keys(rowData).map(function(key) {
						const value = rowData[key];

						$entry.dataset[key] = value;

						return key;
					});
				}

				// add any classes
				if( $response.dataset.classes ){
					const classes = $response.dataset.classes.split(' ');

					for( let i = 0; i < classes.length; i++ ){
						$card.wrapper.classList.add(classes[i]);
					}
				}

				// add footers
				if( $responseHTML.footer ){
					$content.footer.secondary.root.appendChild( $responseHTML.footer );
				}

				// update header, body, and footer content
				$content.header.secondary.entries
					= $card.header.querySelectorAll('.card-section--secondary > *');
				$content.header.sortable
					= $card.header.querySelectorAll('.data-sort');
				$content.body.secondary.entries
					= $card.body.querySelectorAll('.card-section--secondary > *');
				$content.body.extra.entries
					= $card.body.querySelectorAll('.card-section--extra > *');
				$content.footer.secondary.entries
					= $card.footer.querySelectorAll('.card-section--secondary > *');
				$content.footer.secondary.makeDefault
					= $card.footer.querySelectorAll(selectors.makeDefault);

				// update "make default" checkboxes (if not on all-racecards page)
				if( !$allCards ){
					checkDefault();
				}

				// update active content
				updateActiveContent($targetElem);

				// content loaded, hide loading state
				setLoading(false);

			});

	}

	updateActiveContent($target){

		const data = $target.dataset;
		const selectedID = data.id;
		const callback = {
			before: $target.dataset.callbackBefore,
			after: $target.dataset.callbackAfter
		};

		this.activeID = selectedID;

		// make sure main content section is showing
		if( !this.$card.areas.main.classList.contains(bem.states.active) ){
			this.swapArea($target);
		}

		// update visible header & footer content
		for( let i = 0; i < this.$content.header.secondary.entries.length; i++ ){
			const $block = {
				header: this.$content.header.secondary.entries[i],
				footer: this.$content.footer.secondary.entries[i]
			};
			const entryID = $block.header.dataset.id;

			$block.header.classList.toggle(bem.states.active, selectedID === entryID);
			$block.footer.classList.toggle(bem.states.active, selectedID === entryID);
		}

		// before we show new content, run any desired 'before' callbacks
		if( callback.before ){
			atr.methods.run(this.$card.areas.main, callback.before);
		}

		// update secondary body content
		for( let i = 0; i < this.$content.body.secondary.entries.length; i++ ){
			const $entry = this.$content.body.secondary.entries[i];
			const entryID = $entry.dataset.id;

			$entry.classList.toggle(bem.states.active, selectedID === entryID);
		}

		// now new content on display, run any 'after' callbacks
		if( callback.after ){
			atr.methods.run(this.$card.areas.main, callback.after);
		}

		// update extra body content
		for( let i = 0; i < this.$content.body.extra.entries.length; i++ ){
			const $entry = this.$content.body.extra.entries[i];
			const entryID = $entry.dataset.id;

			$entry.classList.toggle(bem.states.active, selectedID === entryID);
		}

		// set active tab (visuals)
		this.tabs.updateActiveTab($target);

		// calculate row heights
		this.rowHeights(false);

		// reset busy state
		this.busy = false;

	}

	checkDefault(){

		const $makeDefaultAll = this.$content.footer.secondary.makeDefault;

		for( let i = 0; i < $makeDefaultAll.length; i++ ){
			const $makeDefault = $makeDefaultAll[i];

			$makeDefault.checked = $makeDefault.value === userSettings.racecard.defaultTab;
		}

	}

	setupDefaultToggle(){

		const $makeDefaultAll = this.$content.footer.secondary.makeDefault;

		utils.delegate(document, 'change', this.selectors.makeDefault, function(e){

			e.preventDefault();

			if( this.checked ){

				// remove other selected checkboxes in this group
				for( let i = 0; i < $makeDefaultAll.length; i++ ){
					const $makeDefault = $makeDefaultAll[i];

					$makeDefault.checked = $makeDefault.value === this.value;
				}

				userSettings.racecard.defaultTab = this.value;

			}else{

				userSettings.racecard.defaultTab = false;

			}

			updateUserSettings();

		});

	}

	setDefaultTab(){

		// if we're on all-cards page, don't do any of this
		if( this.$allCards ) return;

		const autoload = this.$card.root.dataset.autoload;
		const defaultTab = userSettings.racecard.defaultTab || false;

		// check if we're ignoring the cookie
		// otherwise check if there is a cookie
		if( autoload ){

			const $tab = this.$tabsLinks.querySelector('a[data-id="' + autoload + '"]');

			$tab.click();

		}else if( defaultTab ){

			const $tab = this.$tabsLinks.querySelector('a[data-id="' + defaultTab + '"]');

			$tab.click();

		}

		if( autoload || defaultTab ){

			this.checkDefault();

		}

	}

	swapArea($target){

		const targetData = $target.dataset;
		const targetArea = targetData.area !== undefined ? targetData.area : 'main';

		for( let i = 0; i < this.$card.areas.all.length; i++ ){
			const $area = this.$card.areas.all[i];
			const areaData = $area.dataset;

			$area.classList.toggle(bem.states.active, areaData.area === targetArea );
		}

		if( targetArea !== 'main' ){
			this.tabs.updateActiveTab($target);

			this.busy = false;
		}

	}

	ajaxSwapArea($target){

		const $card = this.$card;
		const $content = this.$content;

		const swapArea = this.swapArea;

		axios
			.get($target.href, {
				headers: {
					'X-Requested-With': 'XMLHttpRequest'
				},
			})
			.then(function(response){

				// get response as an element
				const $response = utils.htmlToElement(response.data);

				// append the content
				$content.root.appendChild($response);

				// update references
				$card.areas.all = $card.root.querySelectorAll(Card.block.selector('area'));

				// update the link
				$target.classList.remove(Card.block.class('tab-swap-ajax'));
				$target.classList.add(Card.block.class('tab-swap'));

				// show the content
				swapArea($target);

			});

	}

	rowHeights(reset){
		for (var i = 0; i < this.$content.body.entries.length; i++) {
			const $row = this.$content.body.entries[i];
			const $content = $row.querySelector('.card-section--primary');
			const currentHeight = $content.offsetHeight;

			$content.style.removeProperty('min-height');

			const actualHeight = $content.offsetHeight;

			if (reset) {
				$content.dataset.minHeight = actualHeight;
			} else {
				$content.dataset.minHeight = actualHeight > currentHeight ? actualHeight : currentHeight;
			}

			$content.style.minHeight = `${$content.dataset.minHeight}px`;
		}
	}

	onResize(){

		this.checkHiddenTab();

		this.rowHeights(true);

	}

	sortableSetup(){

		const $content = this.$content;

		utils.delegate(this.$card.header, 'click', '.data-sort', function(e){

			e.preventDefault();

			const $this = this;
			const data = $this.dataset;
			const orderDirection = data.permanentOrder !== undefined
									? data.permanentOrder
									: data.order === 'desc'
										? 'asc'
										: data.order === undefined
											? 'asc'
											: 'desc';

			if( this.classList.contains('data-sort--active') && data.permanentOrder ) return;

			// Store the new order
			$this.dataset.order = orderDirection;

			// Remove old sort classes
			const $sortableAll = $content.header.sortable;

			for( let i = 0; i < $sortableAll.length; i++ ){
				const $sortableItem = $sortableAll[i];

				$sortableItem.classList
					.remove('data-sort--active', 'data-sort--asc', 'data-sort--desc');
			}

			$this.classList.add('data-sort--active', 'data-sort--' + orderDirection);

			tinysort($content.body.entries, {
				data: data.sort,
				order: orderDirection
			});

		});

	}

	checkHiddenTab(){

		const $tabs = this.$tabsLinks.querySelectorAll('a');
		const $firstTab = $tabs[0];

		for( let i = 0; i < $tabs.length; i++ ){
			const $tab = $tabs[i];

			if(
				$tab.classList.contains(bem.states.active)
				&& $tab !== $firstTab
				&& $tab.parentNode.classList.contains('hidden--' + this.settings.breakpoint)
				&& viewport.mq(this.settings.breakpoint)
			){

				$firstTab.click();

			}
		}

	}

}

module.exports = () => {

	[].slice
		.call(document.querySelectorAll(Card.block.selector()))
		.forEach($card => new Card($card));

};



// WEBPACK FOOTER //
// ./src/js/layout/card.js